<template>
  <div>
    <v-tabs v-model="tab" height="40">
      <v-tab>Details</v-tab>
      <v-tab>Picture</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-container class="pa-0">
        <v-tab-item>
          <v-form v-model="valid">
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  label="Name"
                  v-model="editedItem.name"
                  :rules="nameRules"
                  required
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-select
                  :items="inventoryCategories"
                  item-text="name"
                  item-value="id"
                  label="Category"
                  :rules="[(v) => !!v || 'Category is required']"
                  v-model="editedItem.category"
                  return-object
                  required
                  filled
                ></v-select>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-select
                  :items="locations"
                  item-text="name"
                  item-value="id"
                  :rules="[(v) => !!v || 'Location is requried']"
                  v-model="editedItem.location"
                  return-object
                  label="Location"
                  required
                  filled
                ></v-select>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-select
                  :disable="!editedItem.location"
                  :items="locationAreas"
                  :loading="loadingLocationAreas"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.locationArea"
                  return-object
                  label="Location area"
                  filled
                ></v-select>
              </v-col>
              <v-col cols="4" class="py-0">
                <v-select
                  :items="currencies"
                  v-model="editedItem.currency"
                  item-text="abbrv"
                  item-value="abbrv"
                  return-object
                  hint="Currency"
                  persistent-hint
                  filled
                ></v-select>
              </v-col>
              <v-col cols="8" class="py-0">
                <v-text-field
                  label="Price"
                  required
                  persistent-hint
                  :prefix="editedItem.currency.symbol"
                  hint="Per unit"
                  type="Number"
                  :rules="priceRules"
                  v-model="editedItem.unitPrice"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-text-field
                  label="Quantity"
                  type="Number"
                  required
                  :rules="quantityRules"
                  v-model="editedItem.quantity"
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-tab-item>
        <v-tab-item>
          <image-upload
            @removeImage="imageToRemove"
            :imageURL.sync="editedItem.imageURL"
            :imagePreview.sync="imagePreview"
          ></image-upload
        ></v-tab-item>
      </v-container>
    </v-tabs-items>
  </div>
</template>

<script>
import { db } from '@/firebaseConfig'
import { mapGetters } from 'vuex'
import ImageUpload from '@/components/ImageUpload.vue'

export default {
  props: {
    formValid: {
      type: Boolean,
      default: false
    },
    editedItem: {
      type: Object,
      default: () => ({
        currency: {
          symbol: '£',
          abbrv: 'GBP',
          name: 'Great Britain Pound'
        }
      })
    },
    extraData: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ImageUpload
  },
  data() {
    return {
      tab: 0,
      submitting: false,
      valid: this.formValid,

      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => (v && v.length > 1) || 'Name must be at least 2 characters'
      ],
      priceRules: [
        (v) => !!v || 'Price is required',
        (v) => (v && v >= 0) || 'Price cannot be less than 0'
      ],
      quantityRules: [
        (v) => !!v || 'Quantity is required',
        (v) => (v && v >= 0) || 'Quantity cannot be less than 0'
      ],
      imagePreview: {},
      locationAreas: [],
      loadingLocationAreas: false
    }
  },
  watch: {
    valid(newVal) {
      this.$emit('update:formValid', newVal)
    },
    imagePreview(newVal) {
      this.extraData.imagePreview = newVal
    },
    'editedItem.location': function(newVal, oldVal) {
      if (newVal?.id != oldVal?.id) {
        this.getLocationAreas()
      }
    }
  },
  computed: {
    ...mapGetters([
      'inventoryCategories',
      'inventoryCategoriesLoading',
      'locations',
      'locationsLoading',
      'currencies',
      'companyId'
    ]),
    actionBtnTitle() {
      return this.editedItem.id ? 'Save material' : 'Add material'
    }
  },
  methods: {
    imageToRemove(url) {
      this.extraData.imageToRemove = url
    },
    async getLocationAreas() {
      if (!this.editedItem.location?.id) {
        return
      }
      this.loadingLocationAreas = true
      this.locationAreas = []

      try {
        const query = await db
          .collection(
            `companies/${this.companyId}/locations/${this.editedItem.location.id}/areas`
          )
          .get()
        const result = []
        query.forEach((doc) => {
          result.push({
            id: doc.id,
            ...doc.data()
          })
        })

        this.locationAreas = result
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingLocationAreas = false
      }
    }
  }
}
</script>
